import { Button, Tooltip } from 'antd'
import { ThumbsDown, ThumbsUp } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useStyles } from 'src/components/chat'

import { useTurnFeedback } from '../useTurnFeedback'

type Props = {
  appToken: string
  threadId: string
  runId: string
}

export const TurnFeedback = ({ appToken, threadId, runId }: Props) => {
  const { t } = useTranslation()
  const { styles, cx } = useStyles()
  const { enabled, rating, pending, setRating } = useTurnFeedback(
    appToken,
    threadId,
    runId
  )

  if (!enabled) return null

  return (
    <>
      <Tooltip title={t('workspaceHome.feedback.helpful')}>
        <Button
          type="text"
          size="small"
          disabled={pending}
          className={cx(
            styles.actionButton,
            rating === true && styles.feedbackActive
          )}
          icon={<ThumbsUp size={14} />}
          aria-label={t('workspaceHome.feedback.helpful')}
          aria-pressed={rating === true}
          onClick={() => setRating(true)}
        />
      </Tooltip>
      <Tooltip title={t('workspaceHome.feedback.notHelpful')}>
        <Button
          type="text"
          size="small"
          disabled={pending}
          className={cx(
            styles.actionButton,
            rating === false && styles.feedbackActive
          )}
          icon={<ThumbsDown size={14} />}
          aria-label={t('workspaceHome.feedback.notHelpful')}
          aria-pressed={rating === false}
          onClick={() => setRating(false)}
        />
      </Tooltip>
    </>
  )
}
